// db.js
import Dexie, { type Table } from "dexie"
import languages from "./languages"
import { parsedUser } from "./GetCurrentUser"

type NotificationRow = {
  id?: number
  status: string
}

type LanguageRow = {
  id?: number
  name: string
  code: string
  select: boolean
}

type InitialPageRow = {
  id?: number
  name: string
}

type SettingRow = {
  id?: string
  application: string
  language: string
}

type UserRow = {
  id?: string
}

type DataworkerDb = Dexie & {
  notifications: Table<NotificationRow, number>
  languages: Table<LanguageRow, number>
  initialPage: Table<InitialPageRow, number>
  settings: Table<SettingRow, string>
  users: Table<UserRow, string>
}

export const db = new Dexie("data-worker_db") as DataworkerDb

db.version(1).stores({
  notifications: "++id, status",
  languages: "++id, name, code, select",
  initialPage: "++id, name",
})
db.version(2).stores({
  notifications: "++id, status",
  languages: "++id, name, code, select",
  initialPage: "++id, name",
  settings: "++id",
})

db.version(3).stores({
  notifications: "++id, status",
  languages: "++id, name, code, select",
  initialPage: "++id, name",
  settings: "++id",
  users: "++id",
})

export const defaultDataDB = async () => {
  const user = parsedUser()
  await Dexie.exists("data-worker_db").then(value => {
    if (!value) {
      //Add languages
      languages.forEach(value => {
        db.languages.add({
          name: value.name,
          code: value.code,
          select: value.select,
        })
      })
      //Add notifications
      db.notifications.add({
        status: "default",
      })

      //Add Settings
      if (user) {
        db.settings.add({
          id: user.ID,
          application: "finance",
          language: "en",
        })
      }
    }
  })
}

export const updateLanguageStatusById = async codeLang => {
  let lang = await db.languages.get({ code: codeLang })
  if (!lang) {
    return
  }

  let distinct = await db.languages
    .filter(value => value.id !== lang.id)
    .toArray()

  await Promise.all(
    distinct
      .filter(value => value.id !== undefined)
      .map(value => db.languages.update(value.id as number, { select: false }))
  )
  if (lang.id !== undefined) {
    await db.languages.update(lang.id, { select: true })
  }
}

export const updateNotificationsStatus = async status =>
  await db.notifications.update(1, { status })

export const getNotificationsStatus = async () => await db.notifications.get(1)

/*const getLanguageUsing = async () => {
  let result = db.languages
    .filter(value => (value.select ? value : ""))
    .toArray()

  let valor = await Promise.resolve(result).then(value => value)
  console.log("RESULT", valor)

  return valor
}*/
